import { Modal } from "@shapr3d/frontend-lib";

import DeleteAccountForm from "../DeleteAccountForm/DeleteAccountForm";

export default function DeleteAccountModal({
  onClose,
  open,
}: {
  onClose: () => void;
  open: boolean;
}) {
  return (
    <Modal open={open} title="Delete your account" size="small" onClose={onClose}>
      <DeleteAccountForm open={open} />
    </Modal>
  );
}
